import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ContactComponent} from "./components/contact.component";
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';

const routes  = [{path:"contact",
                  component:ContactComponent,
                  canActivate:[CanActivateViaAuthGuard]
                       }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ContactRoutingModule { }
